import React, { useEffect, useMemo } from 'react';
import { Entry } from '../library/entry';

const ArchiveGrid: React.FC<{ entries: Entry[]; onOpen: (e: Entry) => void }> = ({ entries, onOpen }) => {
  const urls = useMemo(() => entries.map((e) => (e.preview ? URL.createObjectURL(e.preview) : null)), [entries]);
  useEffect(() => () => urls.forEach((u) => u && URL.revokeObjectURL(u)), [urls]);
  return (
    <div className="archive-grid">
      {entries.map((e, i) => (
        <button key={e.id} className="archive-grid-item" onClick={() => onOpen(e)}>
          {urls[i] ? <img src={urls[i]!} alt="" loading="lazy" /> : <div className="archive-grid-blank" />}
          <span>{new Date(e.date).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' })} · {e.location}</span>
        </button>
      ))}
    </div>
  );
};

export default ArchiveGrid;
